// extracted by mini-css-extract-plugin
module.exports = {"noMatchTitle":"emptyPlaceholder_noMatchTitle__1UCod","noMatchDescription":"emptyPlaceholder_noMatchDescription__30GzX"};